import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import * as dateutil from '@appbase/util/date-helper'
import LeaveManageAdmin from '@hr/components/LeaveManageAdmin/LeaveManageAdmin.vue';


@Component({
    components:{LeaveManageAdmin}
})
export default class LeaveManageAdminList extends Vue {
  //
  // ────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────
  //

  @Prop({ type: Array }) items!: Array<any>

  
  
}
